
export default () => {

    const sliders = document.querySelectorAll('.slider')

    sliders.forEach(wrapper => {

        const container = wrapper.querySelector('.slider-viewport')
        const controlsContainer = wrapper.querySelector('.slider-controls')
        const items = 1
        const navPosition = 'bottom'
        const autoHeight = true

        const onInit = () => {
            wrapper.classList.remove('hide')
        }

        tns({
            container,
            controlsContainer,
            items,
            navPosition,
            autoHeight,
            onInit
        })
    })
}
